// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  margin: 3px 0;
  box-shadow: 0px 4px 15px 0px rgba(79, 97, 79, 0.1490196078) !important;
  border-radius: 16px;
  box-shadow: none;
  word-break: break-word;
  --color: var(--ion-color-secondary);
  padding: 15px;
}
ion-card ion-card-content {
  border-top: 0.3px solid rgba(126, 167, 105, 0.4509803922);
  padding: 10px 0px;
}
ion-card ion-card-content:first-of-type {
  border: none;
}

ion-col {
  color: var(--ion-color-secondary);
  font-family: AppFont, sans-serif;
  text-align: right;
  text-transform: capitalize;
}
ion-col.header {
  text-align: center;
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--ion-color-secondary);
}
ion-col div {
  text-align: left;
  color: #C1C1C1;
}
ion-col h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  color: var(--ion-color-secondary);
  text-align: left;
  text-transform: capitalize;
}
ion-col h3.right-col {
  text-align: right;
}

.your-order-title {
  text-transform: uppercase;
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
}

.header {
  font-size: 20px;
  font-family: AppFontExtraBold, sans-serif;
}

ion-chip {
  background: #E2DCD5;
  color: var(--ion-color-primary);
  height: 20px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin: 0px;
  font-size: 11px;
}

.reorder-section {
  display: flex;
  justify-content: flex-end;
}

.reorder {
  background: var(--ion-color-primary);
  color: white !important;
  padding: 5px 10px;
  font-family: AppFontBold, sans-serif;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 16px;
  cursor: pointer;
}

.delivery-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.delivery-info .btn {
  background: var(--ion-color-primary);
  padding: 8px 15px;
  border-radius: 16px;
  color: white;
  font-family: AppFontBold, sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/app/components/my-order/my-order.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sEAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mCAAA;EACA,aAAA;AAAF;AAIE;EACE,yDAAA;EACA,iBAAA;AAFJ;AAII;EACE,YAAA;AAFN;;AAMA;EACE,iCAAA;EACA,gCAAA;EACA,iBAAA;EACA,0BAAA;AAHF;AAIE;EACE,kBAAA;EACA,oCAAA;EACA,eAAA;EACA,iCAAA;AAFJ;AAIE;EACE,gBAAA;EACA,cAAA;AAFJ;AAIE;EACE,oCAAA;EACA,eAAA;EACA,iCAAA;EACA,gBAAA;EACA,0BAAA;AAFJ;AAGI;EACE,iBAAA;AADN;;AAMA;EACE,yBAAA;EACA,iCAAA;EACA,oCAAA;AAHF;;AAKA;EACE,eAAA;EACA,yCAAA;AAFF;;AAIA;EACE,mBAAA;EACA,+BAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AADF;;AAGA;EACE,aAAA;EACA,yBAAA;AAAF;;AAEA;EACE,oCAAA;EACA,uBAAA;EACA,iBAAA;EACA,oCAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAEF;AADE;EACE,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,oCAAA;AAGJ","sourcesContent":["\nion-card {\n  margin: 3px 0;\n  box-shadow: 0px 4px 15px 0px rgba(79, 97, 79, 0.1490196078) !important;\n  border-radius: 16px;\n  box-shadow: none;\n  word-break: break-word;\n  --color: var(--ion-color-secondary);\n  padding: 15px;\n  // --preorder-type-chip-border-color:  #F2F2F2;;\n  // --preorder-type-chip-background:  #F2F2F2;;\n  // --preorder-type-chip-color: var(--ion-color-primary);\n  ion-card-content {\n    border-top: 0.3px solid #7EA76973;\n    padding: 10px 0px;\n\n    &:first-of-type {\n      border: none;\n    }\n  }\n}\nion-col {\n  color: var(--ion-color-secondary);\n  font-family: AppFont, sans-serif;\n  text-align: right;\n  text-transform: capitalize;\n  &.header {\n    text-align: center;\n    font-family: AppFontBold, sans-serif;\n    font-size: 16px;\n    color: var(--ion-color-secondary);\n  }\n  div {\n    text-align: left;\n    color:  #C1C1C1;\n  }\n  h3 {\n    font-family: AppFontBold, sans-serif;\n    font-size: 14px;\n    color: var(--ion-color-secondary);\n    text-align: left;\n    text-transform: capitalize;\n    &.right-col {\n      text-align: right;\n    }\n  }\n}\n\n.your-order-title {\n  text-transform: uppercase;\n  color: var(--ion-color-secondary);\n  font-family: AppFontBold, sans-serif;\n}\n.header {\n  font-size: 20px;\n  font-family: AppFontExtraBold, sans-serif;\n}\nion-chip{\n  background:  #E2DCD5;\n  color: var(--ion-color-primary);\n  height: 20px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  margin: 0px;\n  font-size: 11px;\n}\n.reorder-section {\n  display: flex;\n  justify-content: flex-end;\n}\n.reorder {\n  background: var(--ion-color-primary);\n  color: white !important;\n  padding: 5px 10px;\n  font-family: AppFontBold, sans-serif;\n  width: fit-content;\n  border-radius: 16px;\n  cursor: pointer;\n}\n.delivery-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  .btn {\n    background: var(--ion-color-primary);\n    padding: 8px 15px;\n    border-radius: 16px;\n    color: white;\n    font-family: AppFontBold, sans-serif;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
